import { GetDistance } from './GeoFunctions';
import {
    LOCATION_UPDATE_MIN_DISTANCE_ACTIVE_METERS,
    LOCATION_UPDATE_MIN_DISTANCE_IDLE_METERS,
    LOCATION_UPDATE_MIN_DISTANCE_SEARCHING_METERS,
    LOCATION_UPDATE_INTERVAL_ACTIVE_MS,
    LOCATION_UPDATE_INTERVAL_IDLE_MS,
    LOCATION_UPDATE_INTERVAL_SEARCHING_MS,
} from '../config/economyConfig';

const lastUserLocation = { lat: null, lng: null, at: 0 };
const lastTrackingByBooking = {};

const shouldPersist = (state, lat, lng, intervalMs, minDistMeters) => {
    const now = Date.now();
    const minDistKm = minDistMeters / 1000;
    if (state.lat == null || state.lng == null) {
        state.lat = lat;
        state.lng = lng;
        state.at = now;
        return true;
    }
    const dist = GetDistance(state.lat, state.lng, lat, lng);
    const elapsed = now - state.at;
    if (dist < minDistKm && elapsed < intervalMs) {
        return false;
    }
    state.lat = lat;
    state.lng = lng;
    state.at = now;
    return true;
};

/** Conductor disponible sin servicio activo: ~60 s o 80 m. */
export const shouldPersistUserLocation = (lat, lng, mode = 'idle') => {
    const isActive = mode === 'active';
    const isSearching = mode === 'searching';
    const interval = isActive
        ? LOCATION_UPDATE_INTERVAL_ACTIVE_MS
        : isSearching
            ? LOCATION_UPDATE_INTERVAL_SEARCHING_MS
            : LOCATION_UPDATE_INTERVAL_IDLE_MS;
    const minDist = isActive
        ? LOCATION_UPDATE_MIN_DISTANCE_ACTIVE_METERS
        : isSearching
            ? LOCATION_UPDATE_MIN_DISTANCE_SEARCHING_METERS
            : LOCATION_UPDATE_MIN_DISTANCE_IDLE_METERS;
    return shouldPersist(lastUserLocation, lat, lng, interval, minDist);
};

export const shouldPersistTrackingPoint = (bookingId, lat, lng) => {
    const key = String(bookingId || '_');
    if (!lastTrackingByBooking[key]) {
        lastTrackingByBooking[key] = { lat: null, lng: null, at: 0 };
    }
    return shouldPersist(
        lastTrackingByBooking[key],
        lat,
        lng,
        LOCATION_UPDATE_INTERVAL_ACTIVE_MS,
        LOCATION_UPDATE_MIN_DISTANCE_ACTIVE_METERS
    );
};

export const resetLocationThrottler = () => {
    lastUserLocation.lat = null;
    lastUserLocation.lng = null;
    lastUserLocation.at = 0;
    Object.keys(lastTrackingByBooking).forEach((k) => delete lastTrackingByBooking[k]);
};
